import { Dialog, Modal, ModalOverlay } from 'react-aria-components';
import cx from 'clsx';
import type { ReactElement } from 'react';
import styles from '../popup.module.css';
import type { PopupRootProps } from './popup-root';

/**
 * An alternative to `Popup.Root` for use inside nested overlay contexts
 * (e.g. sidebars, dialogs). Uses `ModalOverlay > Modal > Dialog` which
 * properly registers on react-aria's overlay stack, avoiding focus trapping
 * and `ariaHideOutside` conflicts with parent overlays.
 */
export function PopupOverlayRoot({
  children,
  className,
  isScrollable = false,
  portalContainer,
  ...props
}: PopupRootProps): ReactElement {
  const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, ...restProps } = props;

  return (
    <ModalOverlay {...restProps} UNSTABLE_portalContainer={portalContainer}>
      <Modal className={cx(styles.wrapper, className)}>
        <Dialog
          aria-label={ariaLabel}
          aria-labelledby={ariaLabelledBy}
          className={cx(styles.dialog, isScrollable && styles.scrollable)}
        >
          {children}
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
}
